import { createReducer, on } from '@ngrx/store';
import { SyncQueueActions } from './sync-queue.action-types';
import { Edge } from '../../../edge/edge.model';

export interface EdgeSyncStatusEntry {
  isSync: boolean;
  unsyncReason?: string;
}

export interface SyncQueueState {
  committedOperations: Edge.EdgeSyncQueueDocument[];
  uncommittedOperations: Edge.EdgeSyncQueueDocument[];
  errorOrSkippedOperations: Edge.EdgeSyncQueueDocument[];
  isLoading: boolean;
  edgesSyncStatus: { [edgeId: string]: EdgeSyncStatusEntry };
  syncValidation: Edge.EdgeSyncValidation | null;
  committedPage: number;
  uncommittedPage: number;
  errorOrSkippedPage: number;
  committedTotal: number;
  uncommittedTotal: number;
  errorOrSkippedTotal: number;
}

export const initialState: SyncQueueState = {
  committedOperations: [],
  uncommittedOperations: [],
  errorOrSkippedOperations: [],
  isLoading: true,
  edgesSyncStatus: {},
  syncValidation: null,
  committedPage: 0,
  uncommittedPage: 0,
  errorOrSkippedPage: 0,
  committedTotal: 0,
  uncommittedTotal: 0,
  errorOrSkippedTotal: 0,
};

export const syncQueueReducer = createReducer(
  initialState,
  // Add your existing reducers
  on(SyncQueueActions.resetToInitialState, state => ({
    ...initialState,
  })),
  on(SyncQueueActions.setSyncQueueLoading, (state, { isLoading }) => ({
    ...state,
    isLoading,
  })),
  on(SyncQueueActions.getCommittedOperationsSuccess, (state, { items, total, page }) => ({
    ...state,
    committedOperations: page === 0 ? items : [...state.committedOperations, ...items],
    committedTotal: total,
    committedPage: page,
  })),
  on(SyncQueueActions.getUncommittedOperationsSuccess, (state, { items, total, page }) => ({
    ...state,
    uncommittedOperations: page === 0 ? items : [...state.uncommittedOperations, ...items],
    uncommittedTotal: total,
    uncommittedPage: page,
  })),
  on(SyncQueueActions.getErrorOrSkippedOperationsSuccess, (state, { items, total, page }) => ({
    ...state,
    errorOrSkippedOperations: page === 0 ? items : [...state.errorOrSkippedOperations, ...items],
    errorOrSkippedTotal: total,
    errorOrSkippedPage: page,
  })),
  on(SyncQueueActions.getEdgesSyncStatusSuccess, (state, { edgesSyncStatus }) => ({
    ...state,
    edgesSyncStatus: edgesSyncStatus.reduce((acc, curr) => ({
      ...acc,
      [curr.edgeId]: { isSync: curr.isSync, unsyncReason: curr.unsyncReason }
    }), {} as { [edgeId: string]: EdgeSyncStatusEntry })
  })),
  on(SyncQueueActions.validateEdgeSync, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(SyncQueueActions.validateEdgeSyncSuccess, (state, { syncValidation }) => ({
    ...state,
    syncValidation,
    isLoading: false,
  })),
  on(SyncQueueActions.validateEdgeSyncFail, (state) => ({
    ...state,
    isLoading: false,
  }))
);
